module.exports = __webpack_public_path__ + "static/media/tone4_bad.01c8db16.svg";